<template>
  <path
    d="M13 6.99027H14.79C15.24 6.99027 15.46 6.45027 15.14 6.14027L12.35 3.36027C12.15 3.17027 11.84 3.17027 11.64 3.36027L8.86 6.14027C8.54 6.45027 8.76 6.99027 9.21 6.99027H11V17.0103H9.21C8.76 17.0103 8.54 17.5503 8.86 17.8603L11.65 20.6403C11.85 20.8303 12.16 20.8303 12.36 20.6403L15.15 17.8603C15.47 17.5503 15.24 17.0103 14.8 17.0103H13V6.99027Z"
  />
</template>
